<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <span slot="header">搜索</span>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch()">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="客户id"
                          prop="customerid">
              <el-input placeholder="请输入客户id"
                        v-model="search.customerid"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="客户名称"
                          prop="customername">
              <el-input placeholder="请输入客户名称"
                        v-model="search.customername"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetForm('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <el-row>
      <el-button type="primary"
                 @click="onBatchDownload()">批量下载
      </el-button>
      <el-button type="primary"
                 @click="onSearchDownload()">搜索结果导出
      </el-button>
      <el-button type="primary"
                 @click="onBatchComplete()">批量通过
      </el-button>
      <el-button type="primary"
                 @click="onBatchCancel()">批量不通过
      </el-button>
      <br/><br/>
    </el-row>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="batchnumber"
                         label="问卷批次编号"></el-table-column>
        <el-table-column prop="orderid"
                         label="问卷ID"></el-table-column>
        <el-table-column prop="title"
                         label="问卷标题"></el-table-column>
        <el-table-column prop="adminname"
                         label="完成人"></el-table-column>
        <el-table-column prop="salary"
                         label="报酬(元)"></el-table-column>
        <el-table-column prop="statrttime"
                         label="任务时间">
          <template slot-scope="scope">
            <span>{{scope.row.starttime}}<br/>{{scope.row.endtime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customername"
                         label="所属客户">
          <template slot-scope="scope">
            <span>{{scope.row.customername}}/{{scope.row.customernumber}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="publishtime"
                         label="发布更新时间">
          <template slot-scope="scope">
            <span>{{scope.row.publishtime}}<br/>{{scope.row.lastupdatetime}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <router-link :to="{ path: '/teke-order/detail/'+scope.row.orderid}">
              <el-button type="text"
                         size="mini">详情
              </el-button>
            </router-link>
            <span v-if="scope.row.status === '4' || scope.row.status === '40'">
              <router-link :to="{ path: '/teke-order/review/'+scope.row.orderid}">
                <el-button type="text"
                           size="mini">审核</el-button>
              </router-link>
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        orderid: null,
        customername: null,
        status: [40],
      },
      // 搜索字段申明
      searchFieldType: {
        orderid: Number,
        // status: { 0: Number, 1: Number, 2: Number },
      },
      multipleSelection: [],
      options: {
        status: [
          {id: '2', keyword: '已抢单'},
          {id: '3', keyword: '进行中'},
          {id: '4', keyword: '待审核'},
          {id: '40', keyword: '管理员复审'},
          {id: '5', keyword: '管理员确认'},
          {id: '-1', keyword: '已关闭'},
          {id: '-2', keyword: '审核未通过'},
        ],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () { },
  methods: {
    ...Vuex.mapActions(['getTekeOrderTable', 'batchCompleteTekeOrder']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getTekeOrderTable', params)
    },
    onBatchComplete () {
      let multipleIds = this.multipleSelection.map(item => item.orderid)
      if (multipleIds.length <= 0) {
        this.$message.error('请至少选择批量通过一个')
        return false
      }

      this.$prompt('请输入复审通过原因', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '邮箱格式不正确',
      }).then(({value}) => {
        request.common('batchCompleteTekeOrder', {idlist: multipleIds, revierMessage: value}).then((res) => {
          this.$message({
            showClose: true,
            message: '批量通过问卷成功,成功' + res.data.succeedAmount + '个,共' + multipleIds.length + '个',
            type: 'success',
          })
          this.onSearch()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入',
        })
      })
    },
    onBatchCancel () {
      let multipleIds = this.multipleSelection.map(item => item.orderid)
      if (multipleIds.length <= 0) {
        this.$message.error('请至少选择批量不通过一个')
        return false
      }

      this.$prompt('请输入复审不通过原因', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '邮箱格式不正确',
      }).then(({value}) => {
        request.common('batchCancelTekeOrder', {idlist: multipleIds, errormessage: value}).then((res) => {
          this.$message({
            showClose: true,
            message: '批量不通过问卷成功,成功' + res.data.succeedAmount + '个,共' + multipleIds.length + '个',
            type: 'success',
          })
          this.onSearch()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入',
        })
      })
    },
    onBatchDownload () {
      let detail = []
      detail.push(
        {
          batchnumber: '问卷批次编号',
          orderid: '问卷ID',
          title: '问卷标题',
          adminname: '完成人',
          salary: '报酬(元)',
          starttime: '任务开始时间',
          endtime: '任务结束时间',
          customername: '所属客户',
          customernumber: '所属客户编号',
          publishtime: '发布时间',
          lastupdatetime: '更新时间',
        },
      )
      for (let i = 0; i < this.multipleSelection.length; i++) {
        detail.push(this.multipleSelection[i])
      }
      let fileHeader =
        [
          {key: 'batchnumber', text: '问卷批次编号'},
          {key: 'orderid', text: '问卷ID'},
          {key: 'title', text: '问卷标题'},
          {key: 'adminname', text: '完成人'},
          {key: 'salary', text: '报酬(元)'},
          {key: 'starttime', text: '任务开始时间'},
          {key: 'endtime', text: '任务结束时间'},
          {key: 'customername', text: '所属客户'},
          {key: 'customernumber', text: '所属客户编号'},
          {key: 'publishtime', text: '发布时间'},
          {key: 'lastupdatetime', text: '更新时间'},
        ]
      this.$export('订单列表', detail, {
        fileHeader: fileHeader,
      })
    },
    onSearchDownload () {
      let fileHeader =
        [
          {key: 'batchnumber', text: '问卷批次编号'},
          {key: 'orderid', text: '问卷ID'},
          {key: 'title', text: '问卷标题'},
          {key: 'adminname', text: '完成人'},
          {key: 'salary', text: '报酬(元)'},
          {key: 'starttime', text: '任务开始时间'},
          {key: 'endtime', text: '任务结束时间'},
          {key: 'customername', text: '所属客户'},
          {key: 'customernumber', text: '所属客户编号'},
          {key: 'publishtime', text: '发布时间'},
          {key: 'lastupdatetime', text: '更新时间'},
        ]
      this.$export('订单列表', {
        total: this.pagination.total,
        request: this.getTekeOrderTable,
        requestParams: this.search,
        fileHeader: fileHeader,
      })
    },
    handleSelectionChange (val, index) {
      this.multipleSelection = val
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/teke-order/pages/TekeOrderAuditTable.vue